import type { OfferImpressionConsumer } from "./OfferImpression.delivery";
import type { OfferImpressionEmission } from "./OfferImpression.emit";

type OfferImpressionDelivery = (
  input: OfferImpressionEmission,
  consume: OfferImpressionConsumer
) => Promise<boolean>;
type PendingDelivery = [
  OfferImpressionEmission,
  OfferImpressionConsumer,
  (delivered: boolean) => void,
];

declare global {
  interface Window {
    __ishvaramOfferImpressionDelivery?: OfferImpressionDelivery;
    __ishvaramOfferImpressionPreload?: () => void;
    __ishvaramPendingOfferImpressions?: PendingDelivery[];
  }
}

export function installOfferImpressionDelivery(
  delivery: OfferImpressionDelivery,
  preload: () => void
): () => void {
  window.__ishvaramOfferImpressionDelivery = delivery;
  window.__ishvaramOfferImpressionPreload = preload;
  for (const [input, consume, resolve] of window.__ishvaramPendingOfferImpressions?.splice(0) ??
    []) {
    void delivery(input, consume).then(resolve, () => resolve(false));
  }
  return () => {
    if (window.__ishvaramOfferImpressionDelivery === delivery) {
      delete window.__ishvaramOfferImpressionDelivery;
      delete window.__ishvaramOfferImpressionPreload;
    }
  };
}

export function preloadOfferImpressionEmitter(): void {
  window.__ishvaramOfferImpressionPreload?.();
}

export function deliverOfferImpression(
  input: OfferImpressionEmission,
  consume: OfferImpressionConsumer
): Promise<boolean> {
  const delivery = window.__ishvaramOfferImpressionDelivery;
  if (delivery) return delivery(input, consume);
  return new Promise((resolve) => {
    (window.__ishvaramPendingOfferImpressions ??= []).push([input, consume, resolve]);
  });
}

export function resetOfferImpressionDeliveryBridgeForTests(): void {
  delete window.__ishvaramOfferImpressionDelivery;
  delete window.__ishvaramOfferImpressionPreload;
  delete window.__ishvaramPendingOfferImpressions;
}
